import React from 'react';
import { httpsCallable } from 'firebase/functions';
import { functions } from '../lib/firebase';

const DebugWhoami: React.FC = () => {
  const [data, setData] = React.useState<any>(null);
  const [error, setError] = React.useState<string | null>(null);
  const [loading, setLoading] = React.useState(false);

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const fn = httpsCallable<{}, any>(functions, 'whoami');
      const res = await fn();
      setData(res.data);
    } catch (e: any) {
      setError(e?.message || 'Failed to load whoami');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => {
    load();
  }, []);

  return (
    <div className="p-6">
      <h1 className="text-2xl font-semibold mb-4">Debug: whoami</h1>
      <button onClick={load} className="btn-primary mb-4" disabled={loading}>
        {loading ? 'Refreshing…' : 'Refresh'}
      </button>
      {error && <div className="text-sm text-red-600 mb-4">{error}</div>}
      <pre className="bg-gray-100 rounded p-4 text-xs overflow-auto">
        {JSON.stringify(data, null, 2)}
      </pre>
    </div>
  );
};

export default DebugWhoami;
